// const window = require('global/window');
// const { resolvedRoles } = require('@digital-hig/theme-mui/theme-data/lib/build/json/digitalHig2020WebDensityTheme/theme.json');
const modExports = {};

// Purpose: Key for the Isomorphic data point that the server passes to the client
modExports.PRELOADED_STATE_KEY = '__PRELOADED_STATE__';

// PURPOSE: Server, App, and infrastructure keys
modExports.ENVIRONMENT = 'ENVIRONMENT';
modExports.VERSION = 'VERSION';
modExports.MAINTENANCE_MODE = 'MAINTENANCE_MODE';
modExports.VIRTUAL_DIRECTORY = 'VIRTUAL_DIRECTORY';
modExports.HOST = 'HOST';
modExports.DEV_ENV = 'dev';
modExports.NOTSET_ENV = undefined;
modExports.STAGE_ENV = 'stg';
modExports.PROD_ENV = 'prod';
modExports.HTML_MAX_AGE = 'HTML_MAX_AGE';

// PURPOSE: Keys that connect to SSO and user validation
modExports.PKCE_CLIENT_ID = 'PKCE_CLIENT_ID';
modExports.PKCE_ENV = 'PKCE_ENV';
modExports.PKCE_PROFILE_HOST = 'PKCE_PROFILE_HOST';
modExports.APP_PROFILE = 'APP_PROFILE';
modExports.OXYGEN_REDIRECT_URL_KEY = 'autodesk_oxygen_redir_url';

// PURPOSE: Keys that connect with XHR requests
modExports.RETRY_COUNT = 2;

// PURPOSE: App top-level controls for differing "modes"
modExports.IS_PREVIEW = 'isPreview';
modExports.REQUEST_FLAGS = 'requestFlags';
modExports.USE_MOCKS = 'useMocks';

// PURPOSE: Keys that connect with LearnLive Services
modExports.LEARN_LIVE_HOST_COMMON = 'LEARN_LIVE_HOST_COMMON';
modExports.LAP_LEARN_LIVE_SERVICE_HOST = 'LAP_LEARN_LIVE_SERVICE_HOST';

modExports.LEARNING_PLAN_HOST_COMMON = 'LEARNING_PLAN_HOST_COMMON';

// PURPOSE: Keys that connect with Courses
modExports.COURSE_API_HOST = 'COURSE_API_HOST';
modExports.COURSE_PREVIEW_API_HOST = 'COURSE_PREVIEW_API_HOST';
modExports.COURSE_PREVIEW_REQUEST_HOST = 'COURSE_PREVIEW_REQUEST_HOST';
modExports.COURSE_DATA_HOST = 'CONTENTFUL_GRAPHQL_HOST';

// PURPOSE: Keys that connect with Contentul
modExports.CONTENTFUL_GRAPHQL_TOKEN = 'CONTENTFUL_GRAPHQL_TOKEN';
modExports.CONTENTFUL_PREVIEW_GRAPHQL_TOKEN = 'CONTENTFUL_PREVIEW_GRAPHQL_TOKEN';
modExports.CONTENTFUL_ENVIRONMENT_ID = 'CONTENTFUL_ENVIRONMENT_ID';
modExports.CONTENTFUL_SPACE_ID = 'CONTENTFUL_SPACE_ID';

// PURPOSE: List of components and their names
modExports.COMPONENT_INDEX = 'index';
modExports.COMPONENT_COACHINGREQUESTMANAGEMENTLIST = 'coachingRequestManagementList';
modExports.COMPONENT_COACHINGREQUESTMANAGEMENTDETAIL = 'coachingRequestManagementDetail';

modExports.COMPONENT_NOTFOUND = 'notFound';

// PURPOSE: Keys that connect with error handling
modExports.ERROR_TYPE_404 = '404';
modExports.ERROR_TYPE_XHR = 'XHR';
modExports.ERROR_TYPE_AUTHORIZATION = '403';
modExports.ERROR_TYPE_BROWSER = 'BROWSER';
modExports.LOG_LEVEL = 'LOG_LEVEL';
modExports.LOG_LEVEL_DEBUG = 'debug';
modExports.LOG_LEVEL_INFO = 'info';
modExports.LOG_LEVEL_WARN = 'warn';
modExports.LOG_LEVEL_ERROR = 'error';
modExports.CONTENTFUL_CMA_ID = 'CONTENTFUL_CMA_ID';
modExports.LEARN_LIVE_ADMIN_APP_ID = 'LEARN_LIVE_ADMIN_APP_ID';
modExports.JWKSURI = 'JWKSURI';
modExports.VALID_LOG_LEVELS = [
  modExports.LOG_LEVEL_DEBUG,
  modExports.LOG_LEVEL_INFO,
  modExports.LOG_LEVEL_WARN,
  modExports.LOG_LEVEL_ERROR,
];

// PURPOSE: Keys that are values the UI (HTML and CSS)
modExports.HEADER_HEIGHT = '109';
modExports.FOOTER_HEIGHT = '52';

// Purpose: Keys that input strings
modExports.picklistNames = {
  status: 'status', coach: 'coach', geo: 'geo', country: 'country', industrySubSegments: 'industrySubSegments', capabilities: 'capabilities', outcomes: 'outcomes', coachingTypes: 'coachingTypes', customerAccount: 'customerCompanies', cancellationReasons: 'cancellationReasons',
};

// PURPOSE: Create Account to Autodesk website
modExports.ADSK_WEBSITE = 'ADSK_WEBSITE';

// PURPOSE: Keys that connect with AWS
modExports.VALID_AWS_ENVS = [modExports.DEV_ENV, modExports.STAGE_ENV, modExports.PROD_ENV];
modExports.AWS_ENV_VARS = {
  ENVIRONMENT: {
    default: modExports.DEV_ENV,
    validator: (v) => modExports.VALID_AWS_ENVS.includes(v),
  },
  LOG_LEVEL: {
    default: modExports.LOG_LEVEL_ERROR,
    validator: (v) => modExports.VALID_LOG_LEVELS.includes(v),
  },
  HTML_MAX_AGE: {
    default: '86400',
    validator: (v) => RegExp(/^\d+$/).test(v),
  },
  LOGGER_URL: {},
};
const CONTENTFUL_GRAPHQL_HOST_VALUE = 'https://graphql.contentful.com';
// PURPOSE: Keys that change value per environment
modExports.ENVIRONMENT_CONSTANTS = {
  dev: {
    ENVIRONMENT: 'dev',
    APP_PROFILE: 'https://profile-stg.autodesk.com/',
    CONTENTFUL_BASE_URL: 'https://app.contentful.com',
    LOG_LEVEL: 'debug',
    VIRTUAL_DIRECTORY: '',
    CONTENTFUL_GRAPHQL_HOST: CONTENTFUL_GRAPHQL_HOST_VALUE,
    CONTENTFUL_ENVIRONMENT_ID: 'development',
    CONTENTFUL_SPACE_ID: 'ooioaq2tbzyk',
    HTML_MAX_AGE: '86400',
    LEARN_LIVE_HOST_COMMON: 'https://main.learnlive-enrollment-api-dev.autodesk.com',
    LAP_LEARN_LIVE_SERVICE_HOST: 'https://learn-plan-main.learn-one-dev.autodesk.com',
    PKCE_CLIENT_ID: 'JGrCeHAbEqWdomlYnArSSIbVG61ealZMhNuaFPmfK32kxvMI',
    PKCE_ENV: 'stg',
    PKCE_PROFILE_HOST: 'https://developer-stg.api.autodesk.com',
    ADSK_WEBSITE: 'https://www-pt.autodesk.com',
    LEARN_LIVE_ADMIN_APP_ID: '5VwGb2LLta6k14NgJrcfO',
    JWKSURI: 'https://developer-stg.api.autodesk.com/authentication/v2/keys',
    LEARNING_PLAN_HOST_COMMON: 'https://learn-plan-main.learn-one-dev.autodesk.com',
  },
  stg: {
    ENVIRONMENT: 'stg',
    APP_PROFILE: 'https://profile-stg.autodesk.com/',
    CONTENTFUL_BASE_URL: 'https://app.contentful.com',
    LOG_LEVEL: 'warn',
    VIRTUAL_DIRECTORY: '',
    CONTENTFUL_GRAPHQL_HOST: CONTENTFUL_GRAPHQL_HOST_VALUE,
    CONTENTFUL_ENVIRONMENT_ID: 'stage',
    CONTENTFUL_SPACE_ID: 'ooioaq2tbzyk',
    HTML_MAX_AGE: '86400',
    LEARN_LIVE_HOST_COMMON: 'https://main.learnlive-enrollment-api-stg.autodesk.com',
    LAP_LEARN_LIVE_SERVICE_HOST: 'https://learn-plan-main.learn-one-stg.autodesk.com',
    PKCE_CLIENT_ID: 'JGrCeHAbEqWdomlYnArSSIbVG61ealZMhNuaFPmfK32kxvMI',
    PKCE_ENV: 'stg',
    PKCE_PROFILE_HOST: 'https://developer-stg.api.autodesk.com',
    ADSK_WEBSITE: 'https://www-pt.autodesk.com',
    LEARN_LIVE_ADMIN_APP_ID: '6ZOnwJ2uJWzVSiOMv2zmhT',
    JWKSURI: 'https://developer-stg.api.autodesk.com/authentication/v2/keys',
    LEARNING_PLAN_HOST_COMMON: 'https://learn-plan-main.learn-one-stg.autodesk.com',
  },
  prod: {
    ENVIRONMENT: 'prod',
    APP_PROFILE: 'https://profile.autodesk.com/',
    CONTENTFUL_BASE_URL: 'https://app.contentful.com',
    LOG_LEVEL: 'error',
    VIRTUAL_DIRECTORY: '',
    CONTENTFUL_GRAPHQL_HOST: CONTENTFUL_GRAPHQL_HOST_VALUE,
    CONTENTFUL_ENVIRONMENT_ID: 'master',
    CONTENTFUL_SPACE_ID: 'ooioaq2tbzyk',
    HTML_MAX_AGE: '86400',
    LEARN_LIVE_HOST_COMMON: 'https://main.learnlive-enrollment-api.autodesk.com',
    LAP_LEARN_LIVE_SERVICE_HOST: 'https://learn-plan-main.learn-one.autodesk.com',
    PKCE_CLIENT_ID: 'eUAZPiU8NsdOXTbf0i3KmoxKGlLGD8rAxZdfgyHZz4TamBXj',
    PKCE_ENV: 'prod',
    PKCE_PROFILE_HOST: 'https://developer.api.autodesk.com',
    ADSK_WEBSITE: 'https://www.autodesk.com',
    LEARN_LIVE_ADMIN_APP_ID: '2qJpXrUVZysXKKTt0ELYoK',
    JWKSURI: 'https://developer.api.autodesk.com/authentication/v2/keys',
    LEARNING_PLAN_HOST_COMMON: 'https://learn-plan-main.learn-one.autodesk.com',
  },
};

modExports.COACHING_TYPE_MAP = {
  PRODUCT: {
    id: 1,
    label: 'Expert Coaching for Product',
    shortLabel: 'Product',
    canCreateClass: 1,
    multiple: 1,
    key: 'PRODUCT',
    coachingSubTypes: [],
  },
  ADMIN: {
    id: 2,
    label: 'Administrator coaching',
    shortLabel: 'Administrator',
    canCreateClass: 0,
    multiple: 0,
    key: 'ADMIN',
    coachingSubTypes: [],
  },
  SYSTEM: {
    id: 3,
    label: 'Expert Coaching for IT',
    shortLabel: 'System',
    canCreateClass: 1,
    multiple: 0,
    key: 'SYSTEM',
    coachingSubTypes: [],
  },
  ADVISORY: {
    id: 4,
    label: 'Workflow Advisory',
    shortLabel: 'Workflow Advisory',
    canCreateClass: 0,
    multiple: 0,
    key: 'ADVISORY',
    coachingSubTypes: [],
  },
  FASTTRACK: {
    id: 5,
    label: 'Fast track services',
    shortLabel: 'Fast track services',
    canCreateClass: 0,
    multiple: 0,
    key: 'FASTTRACK',
    coachingSubTypes: [],
  },
};

modExports.CANCELLATION_REASON_IDS = {
  OTHER: 5,
};

modExports.REQUEST_STATUS_IDS = {
  CANCELED: 5,
  COMPLETED: 4,
  IN_PROGRESS: 7,
};

modExports.CONTENT_TYPES = {
  course:
  { label: 'Course', type: 'Course' },
  module: { label: 'Module', type: 'Module' },
  tutorial: { label: 'Tutorial', type: 'Tutorial' },
  curated: { label: 'Curated List', type: 'Curated' },
  collection: { label: 'Collection', type: 'Collection' },
  LearnLiveCourse: { label: 'Expert coaching', type: 'LearnLiveCourse' },
  LearnLiveClass: { label: 'Expert coaching', type: 'LearnLiveClass' },
};

modExports.API_ENDPOINTS = {
  CONTENT_ITEM_ACTION: 'v1/items',
};

module.exports = modExports;
